import React, { useEffect, useState } from 'react';
import Login from './components/login';
import Loader from './components/general/loader';
import localStorage from './utils/localStorage';
import fetcher, { Fetcher } from './utils/fetcher';
import ControlPanel from './components/controlPanel';

const App = () => {
  const [loggedIn, setLoggedIn] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const mmToken = localStorage.getMMToken();
    const token = localStorage.getToken();
    if (mmToken && token) {
      validateTokens(token, mmToken);
    } else {
      setLoading(false);
    }
  }, []);

  const validateTokens = (token: string, mmToken: string) => {
    fetcher.login
      .validateTokens(token, mmToken)
      .then(() => {
        Fetcher.setTokenHeader(token);
        Fetcher.setMMTokenHeader(mmToken);
        setTimeout(() => {
          setLoggedIn(true);
          setLoading(false);
        }, 500);
      })
      .catch(() => {
        localStorage.clear();
        Fetcher.clearHeaders();
        setLoading(false);
      });
  };

  const handleLogout = () => {
    Fetcher.clearHeaders();
    setLoggedIn(false);
    setLoading(false);
    localStorage.clear();
  };

  if (loading) {
    return <Loader style={{ width: '100vw', height: '90vh' }} />;
  }

  if (loggedIn) {
    return <ControlPanel handle401={handleLogout} />;
  }

  return <Login onLogin={() => setLoggedIn(true)} />;
};

export default App;
